import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { featureName, reducer, CalendarEffects } from '@app/+calendar/store';
import { EffectsModule } from '@ngrx/effects';
import { mediatipFeatureName } from '@app/+mediatips/store/state';
import { reduceMediatips } from '@app/+mediatips/store/reducer';
import { MediatipEffects } from '@app/+mediatips/store/effects';
import { MediatippsEditDialogComponent } from '@app/+mediatips/dialogs/mediatippsEditDialog/mediatippsEditDialog.component';

@NgModule({
    imports: [
        StoreModule.forFeature(featureName, reducer),
        EffectsModule.forFeature([CalendarEffects]),
          StoreModule.forFeature(mediatipFeatureName, reduceMediatips),
                EffectsModule.forFeature([MediatipEffects])
    ]
})
export class CalendarStateModule { }
